import { alpha } from "@mui/material"
import { PureLightTheme } from "../../styles/theme"
import { COLORS } from "../../styles/variables"

export const Z_INDEX_OVERLAY = 100
export const NAV_BUTTON_OFFSET = 20
export const CLOSE_BUTTON_OFFSET = 10
const SAFE_TOP = 'env(safe-area-inset-top, 0px)'
const SAFE_BOTTOM = 'env(safe-area-inset-bottom, 0px)'
const SAFE_RIGHT = 'env(safe-area-inset-right, 0px)'
export const SLIDE_PADDING = 5
export const EDGE_RESISTANCE = 0.3
export const TRANSITION_DURATION = "0.3s cubic-bezier(0.2, 0, 0, 1)"

/** Max pointer travel (px) still counted as a tap/click for dismiss-outside. */
export const CLICK_DEADZONE_PX = 10
/** Vertical swipe distance (px) required to close the gallery. */
export const VERTICAL_THRESHOLD = 120
/** Ignore synthetic click after swipe-to-close (iOS ghost click). */
export const SUPPRESS_CLICK_AFTER_SWIPE_MS = 300

export const modalStyle = {
  display: "flex",
  alignItems: "center",
  // Overlay dimming: shared MuiBackdrop (alpha ~0.25). Do not paint opaque
  // mobile bgcolor — it hid the backdrop and looked solid black.
}

export const viewportStyle = {
  position: "relative" as const,
  width: "100vw",
  height: "100dvh",
  overflow: "hidden" as const,
  outline: "none",
}

export const closeButtonStyle = {
  position: "absolute" as const,
  top: `calc(${CLOSE_BUTTON_OFFSET}px + ${SAFE_TOP})`,
  right: `calc(${CLOSE_BUTTON_OFFSET}px + ${SAFE_RIGHT})`,
  color: COLORS.WHITE,
  zIndex: Z_INDEX_OVERLAY,
  bgcolor: alpha(COLORS.BLACK, 0.2),
  "&:hover": {
    bgcolor: alpha(COLORS.BLACK, 0.3),
  },
}

export const navButtonBaseStyle = {
  position: "absolute" as const,
  top: "50%",
  transform: "translateY(-50%)",
  color: COLORS.WHITE,
  zIndex: Z_INDEX_OVERLAY,
  bgcolor: alpha(COLORS.BLACK, 0.2),
  "&:hover": {
    bgcolor: alpha(COLORS.BLACK, 0.3),
  },
}

export const prevButtonStyle = {
  ...navButtonBaseStyle,
  left: NAV_BUTTON_OFFSET,
}

export const nextButtonStyle = {
  ...navButtonBaseStyle,
  right: NAV_BUTTON_OFFSET,
}

export const trackStyle = {
  display: "flex" as const,
  height: "100%",
  willChange: "transform" as const,
  touchAction: "none" as const,
}

export const slideStyle = (isMobile: boolean) => ({
  flex: "0 0 100%",
  width: "100%",
  minWidth: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: isMobile ? 0 : SLIDE_PADDING,
})

export const slideImageStyle = {
  maxWidth: "min(90%, 1200px)",
  maxHeight: "100%",
  objectFit: "contain" as const,
  userSelect: "none" as const,
  // Hit-test must include the image so clicks on it do not dismiss.
  pointerEvents: "auto" as const,
  [PureLightTheme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  }
}

export const counterStyle = {
  position: "absolute" as const,
  bottom: `calc(20px + ${SAFE_BOTTOM})`,
  width: "100%",
  textAlign: "center" as const,
  color: COLORS.WHITE,
  pointerEvents: "none" as const,
}
